// extracted by mini-css-extract-plugin
export var actionButton = "_iv-0";
export var fileInput = "_iv-2";
export var paperclip = "_iv-1";